export default __webpack_public_path__ + "static/media/companies.465ef082.svg";